import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation} from 'swiper/modules';
import {faAngleLeft, faAngleRight} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import 'swiper/css';
import 'swiper/css/navigation';
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import defaultImage from '../../assets/image/logo.png';

const breakpoints = {
    300: { slidesPerView: 2, spaceBetween: 5 },
    400: {slidesPerView: 2, spaceBetween: 5},
    640: {slidesPerView: 3, spaceBetween: 10},
    768: {slidesPerView: 3, spaceBetween: 10},
    992: {slidesPerView: 4, spaceBetween: 15},
    1200: {slidesPerView: 6, spaceBetween: 15},
    1400: {slidesPerView: 6, spaceBetween: 20},
};

function Store({array_store}) {
    const navigationPrevRef = React.useRef(null);
    const navigationNextRef = React.useRef(null);

    return (
        <>
            <div className="relative container-fluid" style={{marginTop: "-5px"}}>
                <div className="container">
                    <div className="flex justify-between items-center pb-0.5 border-b border-brand-blue z-1">
                        <h2 className="text-lg font-bold text-brand-blue">Emprendedores / Tiendas</h2>
                        <Link to={`/emprendedores`}
                              className="text-white bg-brand-blue hover:bg-blue-700 transition-colors duration-300 px-2 py-1 rounded-full text-sm font-medium no-underline">
                            Ver Más
                            <FontAwesomeIcon icon={faAngleRight} className="ps-2 text-sm"/>
                        </Link>
                    </div>
                </div>

                <div className="relative container px-1 md:px-4">


                    {/* Flechas de navegación */}
                    <div ref={navigationPrevRef}
                         className="hidden md:flex absolute left-[-2rem] top-1/2 transform -translate-y-1/2 z-10">
                        <button
                            className="h-10 w-10 bg-brand-blue hover:bg-blue-700 transition-colors duration-300 rounded-full text-white flex justify-center items-center shadow-lg">
                            <FontAwesomeIcon icon={faAngleLeft} className="text-xl"/>
                        </button>
                    </div>

                    <div ref={navigationNextRef}
                         className="hidden md:flex absolute right-[-2rem] top-1/2 transform -translate-y-1/2 z-10">
                        <button
                            className="h-10 w-10 bg-brand-blue hover:bg-blue-700 transition-colors duration-300 rounded-full text-white flex justify-center items-center shadow-lg">
                            <FontAwesomeIcon icon={faAngleRight} className="text-xl"/>
                        </button>
                    </div>


                    {/* Swiper */}
                    <Swiper
                        breakpoints={breakpoints}
                        spaceBetween={10}
                        navigation={{
                            prevEl: navigationPrevRef.current,
                            nextEl: navigationNextRef.current,
                        }}
                        onBeforeInit={(swiper) => {
                            swiper.params.navigation.prevEl = navigationPrevRef.current;
                            swiper.params.navigation.nextEl = navigationNextRef.current;
                        }}
                        modules={[Navigation]}
                        className="mySwiper text-center p-2 pb-3"
                    >
                        {
                            array_store.map((category, index) => (

                                <SwiperSlide key={index}>
                                    <Link to={`/${category.slug}`} className='no-underline'>
                                        <div
                                            className="text-center rounded-lg shadow-sm sm:shadow-md border p-1.5 sm:p-3 transform transition-transform duration-300 hover:-translate-y-1 bg-white">
                                            <div className="min-h-[30px] sm:min-h-[40px] flex items-center justify-center">
                                                <p className="text-xs sm:text-sm font-medium mb-0 text-gray-800 line-clamp-1">{category.name}</p>
                                            </div>
                                            <img
                                                src={category.logo || defaultImage}
                                                onError={(e) => { e.target.onerror = null; e.target.src = defaultImage; }}
                                                alt={category.name}
                                                className="w-full object-contain aspect-[1/1] mb-1 sm:mb-2 p-1 sm:p-2"
                                            />
                                        </div>
                                    </Link>
                                </SwiperSlide>
                            ))}
                    </Swiper>
                </div>
            </div>

        </>
    );
}


const mapStateToProps = state => ({
    array_store: state.Home.array_store

})

export default connect(mapStateToProps, {})(Store)